export default __webpack_public_path__ + "static/media/execute_QuestionTheory.54c8ad83.png";